import DatePicker from "common/components/DatePicker";
import React, { useEffect, useState } from "react";
import CreateTodo from "./components/CreateTodo";
import AddRemark from "./components/AddRemark";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";
import Modal from "common/components/Modal";
import { formatDateTime } from "common/constants/functions";

const Todo = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [cancelDelete, setCancelDelete] = useState(null);
  const [isAddRemarkOpen, setIsAddRemarkOpen] = useState(false);
  const [todos, setTodos] = useState([]);
  const { company_id } = JSON.parse(localStorage.getItem("user-auth"));

  const getTodos = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getTodo",
        companyId: company_id,
        taskDate: startDate.toISOString().split("T")[0],
      });
      if (data?.success) {
        setTodos(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleDeleteTodo = async () => {
    try {
      const { data } = await axios.post("", {
        action: "deleteTodo",
        companyId: company_id,
        todoId: cancelDelete,
      });
      if (data?.success) {
        toast.success(data?.msg);
        getTodos();
        setCancelDelete();
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const onCancelDelete = () => {
    setCancelDelete(null);
  };
  useEffect(() => {
    getTodos();
  }, [startDate]);
  const onClose = () => {
    getTodos();
    setIsOpen(false);
  };
  const onAddRemarkClose = () => {
    getTodos();
    setIsAddRemarkOpen(false);
  };

  return (
    <section>
      <h4>
        Todos{" "}
        <span class="text-muted" style={{ fontSize: 16 }}>
          ({todos?.length})
        </span>
      </h4>
      <div className="row justify-content-end">
        <DatePicker {...{ startDate, setStartDate }} />
        <div>
          <button type="button" className="btn btn-primary" onClick={() => setIsOpen(true)}>
            Add
          </button>
        </div>
      </div>
      <div className="row gy-4 mt-1">
        {todos ? (
          todos.map((todo) => (
            <div className="col-lg-4 col-md-6">
              <div className="card h-100">
                <div className="d-flex align-items-end justify-content-between">
                  {todo?.is_general ? (
                    <span className=" text-success fs-12">Public</span>
                  ) : (
                    <span className=" text-primary fs-12">Private</span>
                  )}
                  {!!todo?.is_complete && (
                    <i className="bi bi-check-circle-fill text-success">&nbsp;Completed</i>
                  )}
                </div>
                <h6 className="mb-1">{todo?.task}</h6>
                <span className="text-muted fs-12">
                  Task timeline: {formatDateTime(todo.task_date)}
                </span>
                <p className="mt-3">{todo?.description || "lorem"}</p>
                {todo?.complete_remarks && (
                  <p className="mb-0">
                    <span className="fw-bold">Remark: </span>
                    {todo?.complete_remarks}
                  </p>
                )}
                <div className="d-flex justify-content-end">
                  {!todo?.is_complete && (
                    <button
                      type="button"
                      className="btn text-success bg-light   border"
                      onClick={() => setIsAddRemarkOpen(todo?.id)}
                    >
                      <i className="bi bi-check-lg"></i>
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn text-danger ms-2 bg-light  border"
                    onClick={() => setCancelDelete(todo?.id)}
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <h6 className="mt-5 mx-auto text-muted">No task on this day</h6>
        )}
      </div>
      <Modal
        {...{ isOpen: !!cancelDelete, onClose: onCancelDelete, title: "Confirmation", size: "sm" }}
      >
        <>
          <p>Are you sure you want to delete?</p>
          <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
            <button type="button" className="btn btn-light me-2" onClick={onCancelDelete}>
              No
            </button>
            <button type="submit" className="btn btn-primary" onClick={handleDeleteTodo}>
              Yes
            </button>
          </div>
        </>
      </Modal>
      <CreateTodo {...{ isOpen, onClose, setTodos, startDate }} />
      <AddRemark {...{ isOpen: isAddRemarkOpen, onClose: onAddRemarkClose, setTodos }} />
    </section>
  );
};

export default Todo;
